export default {
    state: {
        account: undefined,
        loggedIn: false
    },
    getters: {
        account(state) {
            return state.account
        },
        loggedIn(state) {
            return state.loggedIn
        },
        authMethod(state) {
            if (state.loggedIn) {
                return state.account.authMethod
            }
            return ""
        },
        prenomNom(state) {
            if (state.loggedIn) {
                return `${state.account.prenom} ${state.account.nom}`
            }
            return ""
        },
        typeContact(state) {
            if (state.loggedIn) {
                return state.account.typeContact
            }
            return 1
        },
    },
    mutations: {
        SET_ACCOUNT_LOGIN(state, data) {
            state.loggedIn = true
            state.account = data
        },
        SET_ACCOUNT(state, data) {
            state.account = data
        },
        LOGOUT(state) {
            state.loggedIn = false
            state.account = undefined
        }
    }
}